import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/layout/PageHeader";
import { FleetGrid } from "@/components/fleet/FleetGrid";
import { CtaBand } from "@/components/layout/CtaBand";
import { Reveal } from "@/components/motion/Reveal";
import { CATEGORIES } from "@/data/fleet";

export default function Categoria() {
  const { categoria } = useParams();
  const cat = CATEGORIES[categoria];
  if (!cat) return <Navigate to="/parco-mezzi" replace />;
  const other = Object.values(CATEGORIES).find((c) => c.slug !== cat.slug);

  return (
    <>
      <Seo title={`${cat.name} a noleggio a Catania`} description={`${cat.short} Noleggio ${cat.name.toLowerCase()} a Catania e in Sicilia orientale con consegna in cantiere.`} path={`/parco-mezzi/${cat.slug}`} />
      <PageHeader
        eyebrow={cat.eyebrow}
        lines={[cat.name, "a noleggio."]}
        description={cat.description}
        crumbs={[{ label: "Parco Mezzi", to: "/parco-mezzi" }, { label: cat.name }]}
        image={cat.image}
      />
      <section className="bg-white py-16 sm:py-24" data-testid={`category-page-${cat.slug}`}>
        <div className="container-x">
          <FleetGrid fixedCategory={cat.slug} />
          <Reveal className="mt-16 flex flex-col items-start justify-between gap-6 border-t border-ink/10 pt-10 sm:flex-row sm:items-center">
            <div>
              <p className="eyebrow">Cerchi altro?</p>
              <p className="display mt-2 text-3xl text-ink">Guarda anche {other.name}</p>
            </div>
            <Link to={`/parco-mezzi/${other.slug}`} className="btn-outline" data-testid="category-other-link">
              {other.name} <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
